import React from 'react';
const LoadMoreIcon = () => {
  return React.createElement("svg", {
    width: '48',
    height: '48',
    viewBox: '0 0 48 48',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("rect", {
    width: '48',
    height: '48',
    rx: '24',
    fill: '#EDF0F3'
  }), React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M25 19H23V23H19V25H23V29H25V25H29V23H25V19Z',
    fill: '#0068EF'
  }));
};
export default LoadMoreIcon;